
export const COVERAGE_TYPES = {
    LIABILITY: "TPL",
    COMBINED: "Combined",
}